"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResearchColony = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var BuildColony_1 = require("../../deferredActions/BuildColony");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var ResearchColony = (function (_super) {
    __extends(ResearchColony, _super);
    function ResearchColony() {
        return _super.call(this, {
            cost: 20,
            tags: [Tags_1.Tags.SPACE, Tags_1.Tags.SCIENCE],
            name: CardName_1.CardName.RESEARCH_COLONY,
            cardType: CardType_1.CardType.AUTOMATED,
            metadata: {
                cardNumber: 'C34',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.colonies(1).asterix().nbsp.cards(2);
                }),
                description: 'Place a colony. MAY BE PLACED WHERE YOU ALREADY HAVE A COLONY. Draw 2 cards.',
            },
        }) || this;
    }
    ResearchColony.prototype.play = function (player) {
        player.game.defer(new BuildColony_1.BuildColony(player, true, 'Select colony for Research Colony'));
        player.drawCard(2);
        return undefined;
    };
    return ResearchColony;
}(Card_1.Card));
exports.ResearchColony = ResearchColony;
//# sourceMappingURL=ResearchColony.js.map